<template>
  <div class="partner-profile-services-box">
    <div>
      <h2 class="services-box-title">
        <strong>{{ title }}</strong>
      </h2>
    </div>
    <div class="ml-3">
      <div v-for="singleDescription in arrayDescription" class="mb-4 flex">
        <svg class="check-blue-icon">
          <use xlink:href="#check-icon"></use>
        </svg>
        <span>{{ singleDescription }}</span>
      </div>
    </div>
    <div class="services-box-price">
      <div class="price_cell">
        <span class="price">€ {{ price }}</span>
        <span class="price_rate"> <span v-if="isPriceMonthly">/ Pm</span></span>
      </div>
    </div>
    <div v-if="link" class="services-box-button">
      <a class="button button_light" :href="link">
        {{ buttonName }}
      </a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  title: {
    type: String,
    required: true,
  },
  description: {
    type: String,
    required: true,
  },
  price: {
    type: [Number, String],
    default: 0,
  },
  link: {
    type: String,
  },
  buttonName: {
    type: String,
    default: '',
  },
  isPriceMonthly: {
    type: Boolean,
    default: false,
  },
});

const arrayDescription = computed(() => {
  return props.description.split('\n');
});
</script>

<style scoped lang="scss">
.partner-profile {
  &-services-box {
    width: 300px;
    max-height: 700px;
    border-radius: 10px;
    background: #edf9ff;
    margin-top: 20px;
    padding-bottom: 20px;
    & .services-box-title {
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      color: #2fabec;
      padding: 20px;
      text-transform: uppercase;
    }
    & .services-box-price {
      font-size: 24px;
      display: flex;
      justify-content: center;
      align-items: flex-end;
    }
    & .services-box-button {
      display: flex;
      justify-content: center;
      align-items: flex-end;
      margin-top: 20px;
    }
  }
}
.check-blue-icon {
  height: 1.5rem;
  width: 1.5rem;
  margin-right: 10px;
  color: #00a8ff;
}
.price {
  font-size: 2.5rem !important;
}
.price_rate {
  font-size: 1rem !important;
}
</style>
